import { selectExternalDepreciationCommentaryTableDisplay } from '../../../redux/features/selectors/commentarySelectors/selectExternalDepreciationCommentary.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { CommentarySubSection } from '../components/CommentarySubsection.tsx';
import { CommentaryTable } from '../components/CommentaryTable.tsx';
import { COMMENTARY_TEXT } from '../consts.ts';

const props = COMMENTARY_TEXT['dep-cost'].subItems['externalDepreciation'];

export const ExternalDepreciation = () => {
  const data = useAppSelector((state) => selectExternalDepreciationCommentaryTableDisplay(state));

  return (
    <CommentarySubSection {...props}>
      <CommentaryTable {...data} />
    </CommentarySubSection>
  );
};
